import { AvatarProfile } from "components/AvatarProfile";
import { ActiveLearningLogo, ProgrammaticLogo } from "components/ProductsLogos";
import { useBreakpoints } from "hooks/useBreakpoints";
import Image from "next/image";
import PluggyTeam from "public/assets/customers/pluggyteam.jpg";

// const customers = [
//   {
//     name: "Neel",
//     role: "CEO",
//     company: "Datanautix",
//     testimonial:
//       "Humanloop has been really transformative for us.  In just hours we’ve been able to train a really high performing model. Without Humanloop this would have taken us weeks. We’ve experimented with Open AI’s GPT-3 API and we just couldn’t get as reliable results. With any other tool it would have taken us this long just to get labeled data. With humanloop we got a great model and deployed it in that time.",
//   },
// ];

export const CustomersSection = () => {
  return (
    <div className="dark">
      <div className="dark:bg-black">
        <div className="container-xl relative py-48 md:pt-[84px] md:pb-[80px]">
          <div className="mb-40 pl-0 text-center font-display text-24-32 font-bold dark:text-white md:mb-64 md:pl-64 md:text-left md:text-32-40">
            What users are saying
          </div>
          <CustomerStory />
        </div>
      </div>
    </div>
  );
};

const CustomerStory = () => {
  const { isMediumWidth } = useBreakpoints();

  return (
    <div className="flex flex-col-reverse overflow-clip rounded-lg dark:border dark:border-gray-800 dark:bg-[#111] dark:shadow-innerDark md:flex-row">
      {/* Drop shadow on card */}
      <div className="flex w-full flex-col gap-8 py-32 px-32 md:w-1/2 md:gap-24 md:py-60 md:px-48 lg:py-[88px] lg:px-80">
        <div className="mb-16 md:hidden">
          <AvatarProfile
            name="Federico Miras"
            company="CEO of Pluggy (YC S21)"
            image="/assets/customers/federico-pluggy.jpg"
            wide={isMediumWidth}
          />
        </div>
        <div className="font-display text-24-28 tracking-wide dark:text-white md:text-[40px] md:leading-[44px]">
          &ldquo;Humanloop solves NLP for Pluggy
        </div>
        <div className=" text-16-26 dark:text-gray-400 md:mt-0">
          {/* I'm really liking how @humanloop solves NLP for Pluggy. 
          It makes our focus to be on our product, using our teams to annotate, 
          without having to care about pains that the AI industry has 
          (hiring ML engineers, building infrastructure, etc.) */}
          It means our focus can be on our product without having to care about
          pains that the AI industry has like hiring ML engineers and building
          infrastructure.&rdquo;
        </div>
        <div className="hidden md:block">
          <AvatarProfile
            name="Federico"
            company="CEO of Pluggy (YC S21)"
            image="/assets/customers/federico-pluggy.jpg"
            wide={isMediumWidth}
          />
        </div>

        <div className="mt-16 dark:text-gray-600 md:mt-0">Tools used</div>
        <div className="flex flex-wrap gap-x-24 gap-y-16  dark:text-gray-600">
          <ProgrammaticLogo size={isMediumWidth ? 24 : 16} />
          <ActiveLearningLogo size={isMediumWidth ? 24 : 16} />
        </div>
      </div>

      <div className="relative  min-h-[300px] w-full md:w-1/2 md:pl-32 ">
        <Image
          src={PluggyTeam}
          alt="Pluggy team"
          layout="fill"
          className="rounded-none rounded-t-[7px] md:rounded-none md:rounded-r-[7px]"
          objectFit="cover"
        />
        {/* <img
          src="/assets/customers/pluggyteam.jpg"
          className="h-full object-cover"
          alt="Pluggy team"
        /> */}
      </div>
    </div>
  );
};
